import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { Field } from '../../UI';

/**
 * Dados do Advogado do devedor (AW2-1134 Etapa 6) — porta de
 * `DadosAdvogado.jsx` real, bloco simples com 2 campos apenas (Nome,
 * Telefone), ambos `disabled={!podeModificarFase || !isEditMode}` — sem
 * campos travados aqui (diferente de `IdentificacaoDevedor.jsx`), confirmado
 * por leitura direta: a produção real já liga os dois campos ao modo de
 * edição sem exceção.
 *
 * `nomeAdvogado`/`telefoneAdvogado` são lidos direto do DTO (`buscarDadosDevedor`)
 * sem mapeamento — nomes de campo já batem entre DTO e UI, mesmo padrão de
 * `makeFormFields` real (`FieldModel.newInstance(values?.nomeAdvogado || '')`).
 * Posicionado depois de `EmailDevedor` e antes de Sócios (Etapa 7) em
 * `AbaDevedor.jsx`, mesma ordem de `DadosDevedor.jsx` real.
 */
export default function DadosAdvogado({
  formFields, podeModificarFase, isEditMode, onChangeCampo, errors,
}) {
  const disabledCampoEditavel = !podeModificarFase || !isEditMode;

  return (
    <>
      <Typography variant="h3" sx={{ mt: 3, mb: 1.5 }}>Dados do Advogado do devedor:</Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1.5fr) minmax(0, 1fr)' },
          gap: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field
          label="Nome:"
          name="nomeAdvogado"
          value={formFields?.nomeAdvogado ?? ''}
          onChange={onChangeCampo}
          disabled={disabledCampoEditavel}
          error={errors?.nomeAdvogado?.error}
          helperText={errors?.nomeAdvogado?.errorMessage}
        />
        <Field
          label="Telefone:"
          name="telefoneAdvogado"
          value={formFields?.telefoneAdvogado ?? ''}
          onChange={onChangeCampo}
          disabled={disabledCampoEditavel}
          error={errors?.telefoneAdvogado?.error}
          helperText={errors?.telefoneAdvogado?.errorMessage}
        />
      </Box>
    </>
  );
}

DadosAdvogado.propTypes = {
  formFields: PropTypes.shape({
    nomeAdvogado: PropTypes.string,
    telefoneAdvogado: PropTypes.string,
  }),
  podeModificarFase: PropTypes.bool,
  isEditMode: PropTypes.bool,
  onChangeCampo: PropTypes.func,
  errors: PropTypes.objectOf(PropTypes.shape({
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
  })),
};

DadosAdvogado.defaultProps = {
  formFields: null,
  podeModificarFase: false,
  isEditMode: false,
  onChangeCampo: () => null,
  errors: {},
};
